import { render, staticRenderFns } from "./Sejue.vue?vue&type=template&id=629967ff&scoped=true&"
import script from "./Sejue.vue?vue&type=script&lang=js&"
export * from "./Sejue.vue?vue&type=script&lang=js&"
import style0 from "./Sejue.vue?vue&type=style&index=0&id=629967ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629967ff",
  null
  
)

export default component.exports